import { MainLayout } from "@/components/MainLayout";
import { SEO } from "@/components/SEO";

export default function ServicesClientsPage() {
  return (
    <MainLayout>
      <SEO 
        title="Clientes - Serviços"
        description="Gerencie clientes de serviços"
        keywords="clientes, serviços"
      />
      <div className="section-delimited">
        <h1 className="text-2xl font-bold mb-4">Clientes</h1>
        <p className="text-muted-foreground">Página em desenvolvimento</p>
      </div>
    </MainLayout>
  );
}

